export enum ApiTags {
  Auth = "Auth",
  Users = "Users",
  Districts = "Districts",
  Schools = "Schools",
  Documents = "Documents",
  DistrictMembers = "DistrictMembers",
  PlatformMembers = "PlatformMembers",
  PlatformDistricts = "PlatformDistricts",
  Shapes = "Shapes",
  CustomLayers = "CustomLayers",
  MapLevels = "MapLevels",
  BoundaryGeometry = "BoundaryGeometry",
  Reports = "Reports",
  /** Live Executive Summary builder phases (step 2); only mutations that change their inputs invalidate it. */
  ExecutiveSummary = "ExecutiveSummary",
  AiChats = "AiChats",
  AiChatMessages = "AiChatMessages",
  Drive = "Drive",
  MapSettingPresets = "MapSettingPresets",
  SampleData = "SampleData",
  AiGlossary = "AiGlossary",
  ChatAlerts = "ChatAlerts",
  Broadcasts = "Broadcasts",
  EdlinkIntegrations = "EdlinkIntegrations",
  EdlinkSettings = "EdlinkSettings",
  EdlinkCustomFieldMappings = "EdlinkCustomFieldMappings",
  Projects = "Projects",
}
